module.exports = __webpack_public_path__ + "img/banner-r.8453d9a6.png";